import { atom } from 'jotai';

export interface IBrandBanner {
  bannerUrl: string;
}

export const $BrandBanner = atom<IBrandBanner>({
  bannerUrl: '',
});
$BrandBanner.debugLabel = '$BrandBanner';
